import React, { forwardRef } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip, { TooltipProps } from "antd/es/tooltip";
import cn from "classnames";

import { Button } from "@mapmycustomers/ui";

import styles from "./ToolButton.module.scss";

interface Props {
  active?: boolean; // to force active-style
  className?: string;
  icon: IconProp;
  iconClassName?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  title: string;
  tooltipProps?: Omit<TooltipProps, "title">;
}

const ToolButton = forwardRef<HTMLDivElement, Props>(
  ({ active, className, icon, iconClassName, onClick, title, tooltipProps, ...props }, ref) => {
    return (
      <div className={cn(styles.btn, className)} ref={ref} {...props}>
        <Tooltip {...tooltipProps} placement="left" title={title}>
          <Button
            block
            className={cn({ [styles.active]: active })}
            icon={<FontAwesomeIcon className={iconClassName} icon={icon} />}
            iconOnly
            onClick={onClick}
            size="large"
          />
        </Tooltip>
      </div>
    );
  }
);

export default ToolButton;
